/* omc-blog-enhance v1 — category labels, reading time, coffee directory, pill counts, issue no. */
(function () {
  if (!/\/blogs\//.test(location.pathname)) return;
  var GRID = '.blog-posts';
  var idx = null;

  function norm(u) {
    try { return (u || '').split('?')[0].replace(/\/$/, ''); } catch (e) { return ''; }
  }

  function byUrl() {
    var m = {};
    (idx || []).forEach(function (r) { m[norm(r.u)] = r; });
    return m;
  }

  function readTime(words) {
    var m = Math.max(1, Math.round((words || 0) / 220));
    return m + ' min read';
  }

  function cards() {
    return Array.prototype.slice.call(document.querySelectorAll('.blog-post-card'));
  }

  function cardUrl(card) {
    var a = card.querySelector('a[href*="/blogs/"]');
    return a ? norm(a.getAttribute('href')) : '';
  }

  function decorate(map) {
    cards().forEach(function (card) {
      if (card.getAttribute('data-omc-done')) return;
      var rec = map[cardUrl(card)];
      if (!rec) return;
      card.setAttribute('data-omc-done', '1');
      card.setAttribute('data-omc-cat', rec.c || '');

      var content = card.querySelector('.blog-post-card__content-text') || card.querySelector('.blog-post-card__content');
      if (!content) return;

      var meta = document.createElement('p');
      meta.className = 'omc-card-meta';
      var bits = [];
      if (rec.c) bits.push('<span class="omc-card-cat">' + rec.c + '</span>');
      bits.push('<span class="omc-card-read">' + readTime(rec.w) + '</span>');
      meta.innerHTML = bits.join('');
      content.insertBefore(meta, content.firstChild);
    });
  }

  function buildDirectory(map) {
    var grid = document.querySelector(GRID);
    if (!grid || document.querySelector('.omc-coffee-dir')) return;

    var coffee = (idx || []).filter(function (r) { return r.c === 'Coffee Guides'; });
    if (coffee.length < 6) return;

    coffee.sort(function (a, b) { return a.t.localeCompare(b.t); });

    var wrap = document.createElement('section');
    wrap.className = 'omc-coffee-dir';
    var head = '<div class="omc-coffee-dir__head">'
      + '<p class="omc-coffee-dir__kicker">The archive</p>'
      + '<h2 class="omc-coffee-dir__title">Post-run coffee, county by county</h2>'
      + '<p class="omc-coffee-dir__sub">' + coffee.length + ' guides to where to get a decent flat white after a run.</p>'
      + '</div>';
    var list = '<ul class="omc-coffee-dir__list">' + coffee.map(function (r) {
      var label = r.t.replace(/^The best post-run coffee shops in\s*/i, '').replace(/^The best post-run coffee in\s*/i, '');
      return '<li><a href="' + r.u + '">' + label + '</a></li>';
    }).join('') + '</ul>';
    wrap.innerHTML = head + list;
    grid.parentNode.insertBefore(wrap, grid.nextSibling);
  }

  function pillCounts() {
    var counts = {};
    (idx || []).forEach(function (r) { if (r.c) counts[r.c] = (counts[r.c] || 0) + 1; });
    document.querySelectorAll('.omc-blogfilter a, .omc-blogfilter button').forEach(function (el) {
      if (el.getAttribute('data-omc-count')) return;
      var t = (el.textContent || '').trim();
      var key = Object.keys(counts).filter(function (k) {
        return k.toLowerCase() === t.toLowerCase();
      })[0];
      if (!key) return;
      el.setAttribute('data-omc-count', '1');
      var s = document.createElement('span');
      s.className = 'omc-pill-count';
      s.textContent = counts[key];
      el.appendChild(s);
    });
  }

  function issueNumber() {
    var mast = document.querySelector('.omc-times-mast__kicker');
    if (!mast || mast.getAttribute('data-omc-issue')) return;
    mast.setAttribute('data-omc-issue', '1');
    var s = document.createElement('span');
    s.className = 'omc-issue-no';
    s.textContent = 'Issue ' + ((idx || []).length || '');
    mast.appendChild(s);
  }

  function run() {
    var map = byUrl();
    decorate(map);
    pillCounts();
    issueNumber();
    buildDirectory(map);
  }

  fetch(window.__OMC_BLOG_INDEX_URL || '/cdn/shop/t/1/assets/omc-blog-index.json')
    .then(function (r) { return r.json(); })
    .then(function (j) {
      idx = j;
      run();
      var mo = new MutationObserver(function () { run(); });
      var g = document.querySelector(GRID);
      if (g) mo.observe(g, { childList: true, subtree: true });
    })
    .catch(function () {});
})();
